import { Component, DestroyRef, Inject, ViewChild, inject, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

export interface StallOwnerData {
  so_id: any;
  id: any;
  stall_num: any;
  data: any;
}

export interface StallData {
  id: any;
  data: any;
}

export interface LayoutData {

  data: any;
}

export interface EventElement {
  id: string;
  stall_num: string;
  size: string;
  price: string;
  status: string;
  owner_name: string;
  owner_number: string;
  action: any;
}

@Component({
  selector: 'app-stall',
  templateUrl: './stall.component.html',
  styleUrls: ['./stall.component.scss']
})
export class StallComponent {
  displayedColumns: string[] = [
    'id',
    'stall_num',
    'price',
    'size',
    'status',
    'owner_name',
    'owner_number',
    'assign_owner',
    'action',
  ];

  ELEMENT_DATA: EventElement[] = [];
  stall_result: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<EventElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: NgxSpinnerService,
  ) { }

  ngAfterViewInit() {
    this.Get_Stall();
    this.dataSource.paginator = this.paginator;
  }

  stallLayout() {
    const dialogRef = this.dialog.open(stall_layout);
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Stall();
    });
  }
  AddStall(id: any) {
    const dialogRef = this.dialog.open(add_edit_stall, {
      data: {
        id: id
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Stall();
    });
  }

  AddStallOwner(so_id: any, id: any, stall_num: any) {
    const dialogRef = this.dialog.open(add_edit_sowner, {
      data: {
        so_id: so_id,
        id: id,
        stall_num: stall_num,
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      this.Get_Stall();
    });

  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Stall() {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_stall().pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.stall_result = data.data
        for (const item of this.stall_result) {
          this.ELEMENT_DATA = this.stall_result.map((item: { stall_num: any; size: any; price: any; status: any; id: any; owner_name: any, owner_number: any; so_id: any; event_id: any; }, index: number) => ({
            srNo: index + 1,
            stall_num: item.stall_num,
            size: item.size,
            price: item.price,
            status: item.status,
            id: item.id,
            owner_name: item.owner_name,
            owner_number: item.owner_number,
            so_id: item.so_id,
            action: item.id
          })
          );
        }
        this.dataSource = new MatTableDataSource<EventElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      }
    );
  }

  DeleteStall(id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Stall?');
    if (buttonClicked === true) {

      this.service.delete_stall(id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.id !== id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Stall Deleted Succesfully");
        });
    }
  }
}

@Component({
  selector: 'add_edit_stall',
  templateUrl: './add_edit_stall.html',
  styleUrls: ['./stall.component.scss'],
  standalone: false
})
export class add_edit_stall {

  StallForm: FormGroup;
  id: any
  result: any;
  private destoryRef = inject(DestroyRef);
  stall_data: any;
  event_id: any;
  stall_num: any;
  price: any;
  description: any;
  size: any;
  calculatedArea: any;
  calculatedVolume: any;
  length: any;
  width: any;
  height: any;

  constructor(
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_edit_stall>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: StallData
  ) {
    this.id = data['id'];
    this.StallForm = this.member.group({
      id: this.id,
      stall_num: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      price: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      length: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      width: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      height: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      size: new FormControl(''),
      description: new FormControl('', [Validators.required])
    });

    // Whenever length, width, or height changes → recalc area & volume
    this.StallForm.valueChanges.subscribe(val => {
      const L = Number(val.length) || 0;
      const W = Number(val.width) || 0;
      const H = Number(val.height) || 0;

      this.calculatedArea = L * W;      // Area = Length × Width
      this.calculatedVolume = L * W * H; // Volume = L × W × H
    });
  }

  ngOnInit(): void {
    this.get_stall_by_id(this.id)
  }

  get_stall_by_id(id: any) {
    this.service.get_stall_by_id(id).subscribe(
      (data: any) => {
        this.stall_data = data.data;
        this.id = this.stall_data[0].id;
        this.stall_num = this.stall_data[0].stall_num;
        this.price = this.stall_data[0].price;
        this.description = this.stall_data[0].description;
        this.size = this.stall_data[0].size;

        const parts = this.size.split('x'); // "10x12x8"
        this.length = parts[0] || 0;
        this.width = parts[1] || 0;
        this.height = parts[2] || 0;
      });
  }

  onFormSubmit() {

    const formData = this.StallForm.value;
    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.StallForm.valid && hasNonEmptyField) {

      const size = `${this.StallForm.value.length}x${this.StallForm.value.width}x${this.StallForm.value.height}`;

      this.StallForm.patchValue({
        size: size,
      })

      if (this.id) {
        this.service.edit_stall(this.StallForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            this.toastr.success("Stall Updated Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_stall(this.StallForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            this.toastr.success("Stall Added Succesfully");
            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}


@Component({
  selector: 'stall_layout',
  templateUrl: 'stall_layout.html',
  styleUrls: ['./stall.component.scss'],
})

export class stall_layout {
  addUserForm: FormGroup;
  user_id: any
  result: any;

  main: any;
  message!: string;
  imagefileURL!: any | ArrayBuffer;
  imagePath: any;
  isOld1: boolean = false;
  image_name: any;
  event_id: any;


  constructor(
    private member: FormBuilder,
    private adduserservice: ServicesService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<stall_layout>,
    @Inject(MAT_DIALOG_DATA) public data: LayoutData
  ) {
    this.addUserForm = this.member.group({
      image_name: '',
    });
  }



  ngOnInit(): void {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.getuserbyid();
  }

  previewpimage(files: any) {
    console.log(files);
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.adduserservice.uploadimage(this.imagefileURL, this.event_id + "/stall_layout").subscribe((data: any) => {
        this.imagePath = data['image_name'];
        console.log(this.imagePath);
        this.isOld1 = false;
        this.addUserForm.patchValue({
          image_name: this.imagePath
        })
      });
    };
  }


  private destoryRef = inject(DestroyRef);



  getuserbyid() {
    this.adduserservice.get_stall_layout().pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
      data => {
        this.main = data;
        this.result = this.main.data;
        this.image_name = this.result?.[0].layout_image;
        this.isOld1 = true;
      }
    )


  }


  onFormSubmit() {
    const ExistedImage = this.isOld1 ? this.image_name : this.imagePath;

    this.addUserForm.patchValue({
      image_name: ExistedImage,
    })
    const formData = this.addUserForm.value;
    // Check if form data contains at least one non-empty field
    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.addUserForm.valid && hasNonEmptyField) {
      this.adduserservice.edit_stall_layout(this.addUserForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
        next: (val: any) => {
          if (val.flag === true) {
            this.toastr.success(val.msg);
            this.dialogRef.close(true);
          } else {
            this.toastr.error(val.msg);
          }
        },
        error: (err: any) => {
          console.error(err);
        },
      });

    } else {
      this.toastr.error('Please fill the form');
    }
  }

}


@Component({
  selector: 'add_edit_sowner',
  templateUrl: './add_edit_sowner.html',
  styleUrls: ['./stall.component.scss'],
  standalone: false
})
export class add_edit_sowner {

  StallForm: FormGroup;
  so_id: any
  result: any;
  private destoryRef = inject(DestroyRef);
  owner_data: any;
  event_id: any;
  stall_id: any;
  selectedStall_id: any;
  owner_name: any;
  email: any;
  address: any;
  owner_number: any;
  company_name: any;
  website: any;
  youtube: any;
  facebook: any;
  instagram: any;
  notes: any;
  stall_num: any;
  id: any;
  message!: string;
  imagefileURL!: any | ArrayBuffer;
  imagePath: any;
  isOld1: boolean = false;
  image_name: any;

  constructor(
    private member: FormBuilder,
    private service: ServicesService,
    private dialogRef: MatDialogRef<add_edit_sowner>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: StallOwnerData
  ) {
    this.so_id = data['so_id'];
    this.stall_id = data['id'];
    this.stall_num = data['stall_num'];
    this.StallForm = this.member.group({
      so_id: this.so_id,
      stall_num: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      stall_id: new FormControl(''),
      image_name: new FormControl(''),
      owner_name: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      owner_number: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      company_name: new FormControl('', [Validators.required, Validators.pattern(/^(\s*\S+\s*)+$/),]),
      email: new FormControl(''),
      address: new FormControl(''),
      website: new FormControl(''),
      youtube: new FormControl(''),
      facebook: new FormControl(''),
      instagram: new FormControl(''),
      notes: new FormControl('')
    });

  }

  @ViewChild('input') input!: ElementRef<HTMLInputElement>;
  options: { stall_num: string, id: any }[] = [];
  filteredOptions: { stall_num: string, id: any }[] = [];

  filter() {
    const filterValue = this.input.nativeElement.value.toLowerCase();

    this.filteredOptions = this.options.filter(option =>
      option.stall_num.toLowerCase().includes(filterValue)
    );
  }

  onUserSelectionChanged(event: MatAutocompleteSelectedEvent) {
    const selectedOption = event.option.value as { stall_num: string; id: any };
    this.selectedStall_id = selectedOption.id;
    this.stall_num = selectedOption.stall_num;
  }


  get_available_stall() {
    this.service.get_available_stall().pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
      (data: any) => {
        this.options = data.data.map((item: { stall_num: string; id: number }) => ({
          stall_num: item.stall_num,
          id: item.id
        }));
        // this.stall_num = this.options.find(option => option.id === this.id)?.stall_num || '';
      },
      error => {
        this.toastr.error('Failed to load users');
      }
    );
  }

  ngOnInit(): void {
    this.event_id = sessionStorage.getItem('Event_ID');
    this.get_stall_owner_by_id(this.so_id);
    // this.get_available_stall();
  }

  get_stall_owner_by_id(so_id: any) {
    this.service.get_stall_owner_by_id(so_id).subscribe(
      (data: any) => {
        this.owner_data = data.data;
        this.so_id = this.owner_data[0].so_id;
        this.stall_id = this.owner_data[0].stall_id;
        this.stall_num = this.owner_data[0].stall_num;
        this.image_name = this.owner_data[0].image_name;
        this.owner_name = this.owner_data[0].owner_name;
        this.email = this.owner_data[0].email;
        this.owner_number = this.owner_data[0].owner_number;
        this.company_name = this.owner_data[0].company_name;
        this.address = this.owner_data[0].address;
        this.website = this.owner_data[0].website;
        this.youtube = this.owner_data[0].youtube;
        this.facebook = this.owner_data[0].facebook;
        this.instagram = this.owner_data[0].instagram;
        this.notes = this.owner_data[0].notes;
      });
    this.isOld1 = true;

  }

  previewpimage(files: any) {
    console.log(files);
    if (files.length === 0) {
      return;
    }
    var mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.message = 'Only images are supported.';
      return;
    }
    var reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagefileURL = reader.result;
      this.service.uploadimage(this.imagefileURL, this.event_id + "/stall").subscribe((data: any) => {
        this.imagePath = data['image_name'];
        console.log(this.imagePath);
        this.isOld1 = false;
        this.StallForm.patchValue({
          image_name: this.imagePath
        })
      });
    };
  }

  onFormSubmit() {

    const formData = this.StallForm.value;

    const hasNonEmptyField = Object.values(formData).some(value => value !== null && value !== '');
    if (this.StallForm.valid && hasNonEmptyField) {
      const ExistedImage = this.isOld1 ? this.image_name : this.imagePath;
      console.log(ExistedImage);

      this.StallForm.patchValue({
        stall_id: this.selectedStall_id ? this.selectedStall_id : this.stall_id,
        image_name: ExistedImage,
      });

      if (this.so_id) {
        this.service.edit_stall_owner(this.StallForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({
          next: (val: any) => {
            if (val.flag == true) {
              this.toastr.success(val.msg);
            } else {
              this.toastr.error(val.msg);
            }

            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      } else {
        this.service.add_stall_owner(this.StallForm.value).pipe(takeUntilDestroyed(this.destoryRef)).subscribe({

          next: (val: any) => {
            if (val.flag == true) {
              this.toastr.success(val.msg);
            } else {
              this.toastr.error(val.msg);
            }

            this.dialogRef.close(true);
          },
          error: (err: any) => {
            console.error(err);
          },
        });
      }
    } else {
      this.toastr.error("Please Fill Required Fields")
    }
  }
}